import React, { Component } from 'react'
import Sidebar from '../multi/Sidebar'

class Directory extends Component {
  render = () => {
    return (
      <div>

        <div className="heroDirectory vh-25 flex justify-end vh-50-ns">
          <div className="heroText pathway ma3 pa3 bg-black self-end near-white f4 f3-ns">
            Local Website and Maps
          </div>
        </div>


        <div id="maincontent" className="w-100 pa2 bg-moon-gray flex flex-column flex-row-l items-start-l">

          <Sidebar/>

          <div id="content" className="w-100 pl2-l">

          <article className="pa4 mb3 bg-white">
              <div className="head pathway w-100 flex flex-row justify-between items-end bb2">
                <div className="title f3 f2-m f1-l">
                  Eureka Directory
                </div>
              </div>
              <hr className="w-100 mt1 mb3"/>
              <div className="bod droid f5 lh-copy">
                  <a className="link db dark-blue hover-moon-gray mb2 mt4" href="http://www.eureka.mo.us">City of Eureka Official Website</a>    
                  <a className="link db dark-blue hover-moon-gray mb2" href="http://www.eureka.mo.us/departments/administration/applications-forms">City of Eureka Applications/Forms</a>
                  <a className="link db dark-blue hover-moon-gray mb2" href="http://www.eureka.mo.us/departments/police">Eureka Police Department</a>
                  <a className="link db dark-blue hover-moon-gray mb2" href="http://www.eureka.mo.us/departments/parks-recreation">Eureka Parks and Recreation</a>
                  <a className="link db dark-blue hover-moon-gray mb2" href="http://www.rsdmo.org/Pages/default.aspx">Rockwood School District</a>
                  <a className="link db dark-blue hover-moon-gray mb2" href="http://www.efpd.org">Eureka Fire Dept</a>
                  <a className="link db dark-blue hover-moon-gray mb2" href="http://eureka.mo.us/government/boards-and-commissions">Contact information for board members/officials</a>
                  <a className="link db dark-blue hover-moon-gray mb2" href="http://www.bing.com/maps?&ty=18&q=Eureka%2c%20MO&vdpid=5096633862876823554&mb=38.524166~-90.704323~38.475857~-90.591583&ppois=38.5000114440918_-90.6479530334473_Eureka%2c%20MO_~&cp=38.500011~-90.647953&v=2&sV=1&FORM=MIRE">Map of Eureka</a>
              </div>
            </article>

          </div>
        </div>
      </div>
    )
  }
}

export default Directory


// WEBPACK FOOTER //
// ./src/components/pages/Directory.js